module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kMGXo"))).then(() => parcelRequire('dJXJK'));